import { createContext, useContext } from 'react'

import { RoleCategoriesConfig } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'

export const RoleCategoriesContext = createContext<RoleCategoriesConfig | undefined>(undefined)

export const useRoleCategoriesContext = () => useContext(RoleCategoriesContext)
